import * as base from '../../index';

export default base.default;

export const getStaticPaths = base.getStaticPaths;

export const getStaticProps = base.getStaticProps;
